import LegalDocumentPage from '../components/LegalDocumentPage'
import {
  privacyContent,
  PRIVACY_LAST_UPDATED,
} from '../content/privacyContent'

const PrivacyPolicy = () => (
  <LegalDocumentPage
    contentByLanguage={privacyContent}
    lastUpdated={PRIVACY_LAST_UPDATED}
  />
)

export default PrivacyPolicy
